import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { 
      getServiceProviderDetails,
      getCompanyContactsAPI,
      insertUpdateServiceProvider,
      deleteServiceProvider,
      getCompanyTypes,
      getCompanyByType
     } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { useRef } from "react";

export const AssetServiceProvider = () => {

  const params = useParams();
  const history = useNavigate();
  const dispatch = useDispatch();
  const AssetId=params.Asset;
  const [companyDetails, setCompanyDetails] = useState([]);
  const [draweropen,setdraweropen]=useState(false);
  const [companyContacts,setCompanyContacts]=useState([]);
  const [companyTypes, setCompanyTypes] = useState([]);
  const [selectedCompanyType, setSelectedCompanyType] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [mode, setMode] = useState(null);
  const [assetCompanyXRefId, setAssetCompanyXRefId] = useState(0);
  const [showModel, setShowModel] = useState(false);
  const serviceProviderRef=useRef();

  const fetchCompanyContact=async(id)=>{
    try{
      const list = await sbaAxios({
        url:getCompanyContactsAPI+`/${id}`
      });
      setCompanyContacts(list);
    }
    catch(e){
      setCompanyContacts([]);
    }
  };

  const fetchServiceProviderDetails = async() =>{
    try{
      const list = await sbaAxios({
        url:getServiceProviderDetails+`/${AssetId}`
      });
      setCompanyDetails(list);
      if(list.length>0)
      {
        fetchCompanyContact(list[0].CompanyID);
      }
    }
    catch(e){
      setCompanyDetails([]);
    }
  };
  const rowDataUpdated = (params) => {
    params.api.forEachNode((node, index) => {
        if (index === 0) {
            node.setSelected(true);
        }
    });
}

  const fetchCompanyTypes = async() => {
    try{
      const list = await sbaAxios({
        url: getCompanyTypes
      });
      setCompanyTypes(list);
    }catch(e){
      setCompanyTypes([]);
    }
  };

  const fetchCompanies = async() => {
    try{
      const list = await sbaAxios({
        url:getCompanyByType+`/${selectedCompanyType?.CompanyTypeID}`,
      });
      setCompanies(list);
    }
    catch(e){
      setCompanies([]);
    }
  };

  const addServiceProvider = async() => {
    try{


      if( !selectedCompany?.CompanyID || !selectedCompanyType?.CompanyTypeID)
      {
        toast.error("Please Select All the Fields");
        return 
      }
     const res= await sbaAxios({
        url:insertUpdateServiceProvider,
        method:'post',
        params:{
          assetCompanyXRefId: 0,
          CompanyId:selectedCompany?.CompanyID,
          CompanyTypeId:selectedCompanyType?.CompanyTypeID,
          AssetId:AssetId
        }
      });
      if(res==-2)
      {
        toast.error("Manager Already Exists for this Asset");
      }
      else {
      toast.success("Service Provider added successfully.");
      }
      closeserviceProvider(); 
    }
    catch(e){
      toast.error("Unable to add Service Provider.");
    }
    finally{
      fetchServiceProviderDetails();
    }
  };

  const editServiceProvider = async() => {
    try{
      
      if( !selectedCompany?.CompanyID || !selectedCompanyType?.CompanyTypeID)
      {
        toast.error("Please Select All the Fields");
        return 
      }
      await sbaAxios({
        url:insertUpdateServiceProvider,
        method:'post',
        params:{
          assetCompanyXRefId: assetCompanyXRefId,
          CompanyId:selectedCompany?.CompanyID,
          CompanyTypeId:selectedCompanyType?.CompanyTypeID,
          AssetId:AssetId
        }
      });
      toast.success("Service Provider Updated successfully.");
      closeserviceProvider();

    }
    catch(e){
      toast.error("Unable to update Service Provider.");
    }
    finally{
      fetchServiceProviderDetails();
    }
  };

  useEffect(()=>{
    fetchCompanies();
  },[selectedCompanyType]);

  useEffect(() => {
    fetchServiceProviderDetails();
    fetchCompanyTypes();
  },[]);

  const actionCellRenderer = (params) => {
    return (
      <div className="actions-cell">
        <i 
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} 
          onClick={() => {
            handleEditClick(params);
          }}
        ></i>
        <i 
          className="fa fa-trash"
          style={{ color: "red", margin: "0 8px", cursor: "pointer" }} 
          onClick={() => {
            handleDeleteClick(params);
          }}
        ></i>
      </div>
    );
};


  const companyColDef = [
    { field: "CompanyName", headerName: "Company Name", },
    { field: "CompanyType", headerName: "Company Type" },
    {
      headerName: "Action",
      field: "Action",
      cellRenderer: actionCellRenderer, // Use custom cell renderer for buttons
      sortable: false,
      filter: false,
      suppressRowClickSelection:true,
      maxWidth:200
    }
  ]
  const contactColDef = [
    { field: "ContactName", headerName: " Name" },
    { field: "BusinessUnit", headerName: "Job Role" },
    { field: "PhoneNum", headerName: "Phone" },
    { field: "Email", headerName: "Business Email" },
  ]
  const defColDef = { flex: 1, filter: "agTextColumnFilter", minWidth: 100,resizable:true };

  const handleCompanyTypeChange = (e) => {
    setSelectedCompanyType(e.value);
    setSelectedCompany(null);
  };

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.value);
  };

  const handleEditClick = (params) => {
    setMode("EDIT");
    setAssetCompanyXRefId(params.data.AssetCompanyXRefId);
    setSelectedCompanyType({
        CompanyName: null,
        CompanyType: params.data.CompanyType,
        CompanyID: 0,
        CompanyTypeID: params.data.CompanyTypeID,
        AssetCompanyXRefId: 0
    });
    setSelectedCompany({
        CompanyName: params.data.CompanyName,
        CompanyType: params.data.CompanyType,
        CompanyID: params.data.CompanyID,
        CompanyTypeID: params.data.CompanyTypeID,
        AssetCompanyXRefId: 0
    })
    openserviceProvider();  
  };

  const handleDeleteClick = (params) => {
    setAssetCompanyXRefId(params.data.AssetCompanyXRefId);
    setShowModel(true);  
  };

  const handleDeleteConfirm = async() => {
    try{
      await sbaAxios({
        url:deleteServiceProvider+`/${assetCompanyXRefId}`
      });
      toast.success("Service Provider Deleted successfully");
      setCompanyContacts([]);
    }
    catch(e){
      toast.error("Unable to delete Service Provider");
    }
    finally{
      setShowModel(false);
      fetchServiceProviderDetails();
    }
  };

  const openserviceProvider = () =>
  {
    setdraweropen(true);
  };

  const closeserviceProvider = () =>
  {
    setdraweropen(false);
    setSelectedCompany(null);
    setSelectedCompanyType(null);
    setCompanies([]);
    setMode(null);
  };

  return (
    <>
    <div className="serviceProvider-tab">
       <div className="row m-0">
          <div className="col-md-1 ms-auto" style={{ width: "max-content" }} >
            <button 
              className='p-sm-btn mx-1' 
              onClick={()=>{
                setMode("ADD")
                openserviceProvider();
              }}
            >
                <i className="fa-solid fa-plus"/> Add
            </button>
          </div>
       </div>
            Service Provider
            <div className="ag-theme-alpine mb-3" style={{height:"200px"}}>
                <AgGridReact 
                  rowData={companyDetails} 
                  onRowClicked={(e) => fetchCompanyContact(e.data.CompanyID)} 
                  rowSelection="single" 
                  columnDefs={companyColDef} 
                  defaultColDef={defColDef}  
                  ref={serviceProviderRef}
                  onRowDataUpdated={rowDataUpdated}
                />
            </div>

           Contacts
            <div className="ag-theme-alpine mb-3" style={{height:"200px"}} >
                <AgGridReact rowData={companyContacts} columnDefs={contactColDef} defaultColDef={defColDef} />
            </div>
    </div>
    <SBADrawer open={draweropen} setOpen={setdraweropen} close={false} title={mode==="ADD"?'Add Service Provider':'Update Service Provider'}>
        <div>
            <label className="header-container m-1"><b>Company Type </b></label>
            <div>
            <SBAComboBox
                  className="w-100"
                  data={companyTypes}
                  textField={"CompanyType"}
                  valueField={"CompanyTypeID"}
                  value={selectedCompanyType}
                  onChange={handleCompanyTypeChange}
                  popupSettings={{ className: "modalDD" }}
                />
            </div>
            <br></br>
            <label className="header-container m-1"><b>Company Name</b></label>
            <div>
            <SBAComboBox
                  className="w-100"
                  data={companies}
                  textField={"CompanyName"}
                  valueField={"CompanyID"}
                  value={selectedCompany}
                  onChange={handleCompanyChange}
                  popupSettings={{ className: "modalDD" }}
                />
             </div>
           
            <div className="mt-4">
                <button className="s-sm-btn mx-1" onClick={closeserviceProvider}>
                    Cancel
                </button>
                <button className="p-sm-btn mx-1" onClick={mode==="ADD"?addServiceProvider:editServiceProvider}>
                    {mode==="ADD"?'Add':'Update'}
                </button>

            </div>
        </div>
    </SBADrawer>
    <Modal show={showModel} onHide={() => setShowModel(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Service Provider</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>The selected Service Provider will be deleted permanently. Are you sure?</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => setShowModel(false)}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleDeleteConfirm}
            >
              Delete
            </button>
          </Modal.Footer>
        </Modal>
    </>
  );
};
